export const noScrollClass = 'vui-no-scroll';
